<template>
  <div align="center">
    <div
        class="registration mb-auto"
        style="max-width: 32rem; text-align: center"
    >
      <h2>Регистрация</h2>

      <form
          v-if="registrationStep === 0"
          class="verification-form"
          method="POST"
          @submit="checkPhone"
      >
        <div
            v-if="phone_errors.length"
            class="registration-form-errors"
        >
          <ul>
            <li v-for="error in phone_errors" :key="error">{{ error }}</li>
          </ul>
        </div>
        <div class="registration-form-row">
          <input
              v-model="phonenumber"
              name="phonenumber"
              placeholder="Введите номер телефона в формате +7(555)444/33/22"
              type="text"
              @keypress="checkPhoneNumber($event)"
              @keyup="formatPhoneNumber($event)"
          />
        </div>
        <div class="verification-form-row">
          <button
              id="phone-form-submitButton"
              class="verification-form-button verification-form-buttonFilled"
              type="submit"
          >
            Продолжить
          </button>
        </div>
      </form>

      <form
          v-if="registrationStep === 1"
          class="verification-form"
          method="POST"
          @submit="checkVerification"
      >
        <div
            v-if="verification_errors.length"
            class="registration-form-errors"
        >
          <ul>
            <li v-for="error in verification_errors" :key="error">{{ error }}</li>
          </ul>
        </div>
        <div
            v-if="verification_messages.length"
            class="registration-form-messages"
        >
          <ul>
            <li v-for="error in verification_messages" :key="error">{{ error }}</li>
          </ul>
        </div>
        <div class="verification-form-row verification-form-halfinput">
          <input
              v-model="verification_code_input"
              name="verification_code_input"
              placeholder="Код подтверждения"
              type="text"
          />
          <a href="#" v-on:click="resendVerification">Выслать код повторно</a>
        </div>
        <div class="verification-form-row">
          <p>Если SMS с кодом так и не пришло, то обратитесь в <a :href="pd_support_link" target="_blank">службу
            технической поддержки</a></p>
        </div>
        <div class="verification-form-row">
          <button
              id="verification-form-submitButton"
              class="verification-form-button verification-form-buttonFilled"
              type="submit"
          >
            Подтвердить
          </button>
        </div>
      </form>

      <form
          v-if="registrationStep === 2"
          class="registration-form"
          method="POST"
          @submit="checkRegistration"
      >
        <div
            v-if="registration_errors.length"
            class="registration-form-errors"
        >
          <ul>
            <li v-for="error in registration_errors" :key="error">{{ error }}</li>
          </ul>
        </div>
        <div class="registration-form-row required">
          <input
              v-model="lastname"
              name="lastname"
              placeholder="Фамилия"
              type="text"
              @keypress="onlyLetterInput($event)"
          />
        </div>
        <div class="registration-form-row required">
          <input
              v-model="firstname"
              name="firstname"
              placeholder="Имя"
              type="text"
              @keypress="onlyLetterInput($event)"
          />
        </div>
        <div class="registration-form-row">
          <input
              v-model="thirdname"
              name="thirdname"
              placeholder="Отчество"
              type="text"
              @keypress="onlyLetterInput($event)"
          />
        </div>
        <div class="registration-form-row">
          <input
              :value="phonenumber"
              disabled
              placeholder="Телефон"
              type="text"
          />
        </div>
        <div
            v-if="captchaActive"
            id="registration-form-captcha"
            class="registration-form-row"
        >
          <Recaptcha
              ref="recaptcha"
              @recaptchaExpired="registrationRecaptchaExpired"
              @recaptchaReseted="registrationRecaptchaReseted"
              @recaptchaVerified="registrationRecaptchaVerified"
          />
        </div>
        <div class="registration-form-row">
          <div class="registration-form-checkbox">
            <span class="registration-form-checkbox-wrapper">
              <input
                  v-model="permit_sms_messages"
                  name="permit_sms_messages"
                  type="checkbox"
              />
            </span>
            <label>
              Соглашаюсь на получение SMS-уведомлений
            </label>
          </div>
        </div>
        <div class="registration-form-row">
          <div class="registration-form-checkbox">
            <span class="registration-form-checkbox-wrapper">
              <input
                  v-model="agreement1"
                  name="agreement1"
                  type="checkbox"
              />
            </span>
            <label>
              Нажимая на кнопку &quot;Зарегистрироваться&quot;, вы соглашаетесь с <a :href="pd_termsofuse"
                                                                                     target="_blank">Условиями
              использования</a> и <a :href="pd_processing_policy" target="_blank">Политикой обработки персональных
              данных</a>
            </label>
          </div>
        </div>
        <div class="registration-form-row">
          <div class="registration-form-checkbox">
            <span class="registration-form-checkbox-wrapper">
              <input
                  v-model="agreement2"
                  name="agreement2"
                  type="checkbox"
              />
            </span>
            <label>
              Соглашаюсь с <a :href="pd_conditions" target="_blank">Условиями обработки персональных данных</a> в
              соответствии с <a :href="pd_policy" target="_blank">Политики в отношении обработки ПДН</a>
            </label>
          </div>
        </div>
        <div class="registration-form-row">
          <button
              id="registration-form-backButton"
              class="registration-form-button"
              type="button"
              @click="resetRegistration"
          >
            Назад
          </button>
          <button
              id="registration-form-submitButton"
              class="registration-form-button registration-form-buttonFilled"
              type="submit"
          >
            Регистрация
          </button>
        </div>
      </form>

      <div
          v-if="registrationStep === 3"
          class="registration-success"
      >
        <template v-if="afterRegisterTextFormatted">
          <div v-html="afterRegisterTextFormatted"></div>
        </template>
        <template v-else>
          Регистрация завершена.
        </template>

      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Recaptcha from "./Recaptcha";

export default {
  name: 'Registration',
  props: {},
  data() {
    return {
      phone_errors: [],
      verification_errors: [],
      verification_messages: [],
      registration_errors: [],
      referral_hash: null, // хэш реферальной программы
      firstname: null, // имя при регистрации
      lastname: null, // фамилия при регистрации
      thirdname: null, // отчество при регистрации
      phonenumber: null, // номер телефона при регистрации
      permit_sms_messages: null, // согласие на получение SMS-уведомлений
      agreement1: null, // состояние input'a галочки при регистрации
      agreement2: null, // состояние input'a галочки при регистрации
      attempts: 0, // количество попыток регистрации (для капчи)
      pd_termsofuse: null, // ссылка на условия использования
      pd_processing_policy: null, // ссылка на политику
      pd_conditions: null, // ссылка на условия
      pd_policy: null, // ссылка на политику конфиденциальности
      pd_support_link: null, // ссылка на политику конфиденциальности
      verification_code: null, // код верификации
      verification_code_input: null, // код верификации введённый пользователем
      verification_code_send_timestamp: null, // timestamp времени отправки последнего кода верификации
      registrationStep: 0,
      captchaActive: false,
      captchaVerified: false,
      captchaCode: false,
    }
  },
  components: {
    Recaptcha
  },
  mounted() {
    if (!!this.$route.params.referral_hash && this.$route.params.referral_hash.length == 32) {
      this.referral_hash = this.$route.params.referral_hash;
    }
    this.getSettings();
  },
  computed: {
    ...mapGetters(
        [
          'PARENT_PERSON', 'SETTINGS'
        ]),
  },
  created() {
  },
  methods: {
    checkPhone: function (e) {
      e.preventDefault();

      this.phone_errors = [];

      if (!this.phonenumber) {
        this.phone_errors.push('Требуется ввести номер телефона.');
      } else {
        let machMask = this.phonenumber.match(/(\+7\()(\d{3})(\))(\d{3})(\/)(\d{2})(\/)(\d{2})/);
        if (machMask === null) {
          this.phone_errors.push('Телефонный номер должен быть в формате +7(111)222/33/44');
        } else {
          this.sendVerification();
        }
      }
    },
    sendVerification: function () {
      this.verification_messages = [];
      this.verification_errors = [];
      this.verification_code = this.generateVerificationCode(4);

      let requestData = {
        phone: this.phonenumber,
        message: "Ваш код верификации: " + this.verification_code
      };

      this.verification_code_send_timestamp = this.getTimestampNow();

      this.$store
          .dispatch('sendVerification', requestData)
          .then(() => {
            this.verification_messages.push("На номер " + this.phonenumber + " отправленно SMS с кодом подверждения.");
            this.registrationStep = 1;
          })
          .catch(err => {
            let errorObj;
            if ((typeof err.response !== "undefined") && (typeof err.response.data !== "undefined")) {
              errorObj = err.response.data;
            } else {
              errorObj = err;
            }
            this.phone_errors.push(this.getErrorTextFromApiJson(errorObj));
          });
    },
    resendVerification: function () {
      this.verification_messages = [];
      this.verification_errors = [];

      if (this.verification_code_send_timestamp) {
        let timestampNow = this.getTimestampNow();

        if (timestampNow > (this.verification_code_send_timestamp + 60000)) {
          this.verification_messages.push("Отправлен новый код подтверждения.");
          this.sendVerification();
        } else {
          this.verification_errors.push("Код может быть отправлен не чаще раза в минуту!");
        }
      }
    },
    getTimestampNow: function () {
      let timeNow = new Date();

      return timeNow.getTime();
    },
    generateVerificationCode: function (length) {
      let result = "",
          characters = "0123456789";
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
      }

      return result;
    },
    checkVerification: function (e) {
      e.preventDefault();

      this.verification_errors = [];
      this.verification_messages = [];

      if (this.verification_code_input) {
        if (this.verification_code) {
          if (this.verification_code === this.verification_code_input) {
            this.registrationStep = 2;
          } else {
            this.verification_errors.push('Неправильный код подтверждения.');
          }
        } else {
          this.verification_errors.push('Ошибка соединения. Перезагрузите страницу.');
        }
      } else {
        this.verification_errors.push('Требуется код подтверждения.');
      }
    },
    checkRegistration: function (e) {
      e.preventDefault();

      this.registration_errors = [];
      this.attempts++;

      if (!this.firstname) {
        this.registration_errors.push('Требуется указать имя.');
      }
      if (!this.lastname) {
        this.registration_errors.push('Требуется указать фамилию.');
      }
      if (!this.phonenumber) {
        this.registration_errors.push('Требуется указать телефон.');
      }
      if ((!this.agreement1) || (!this.agreement2)) {
        this.registration_errors.push('Требуется принять соглашения.');
      }

      if (this.attempts > 5) {
        if (this.captchaActive) {
          // если капча работает, то проверить её значение
          if (this.captchaVerified === false) {
            this.registration_errors.push('Подтвердите, что вы не робот.');
            this.$refs.recaptcha.resetRecaptcha();
          }
        } else {
          if (this.registration_errors.length) {
            // если есть ошибки, то активировать капчу

            this.captchaActive = true;
            this.captchaVerified = false;
            this.captchaCode = false;
          }
        }
      }


      if (this.registration_errors.length === 0) {
        this.submitRegistration();
      }
    },
    registrationRecaptchaExpired: function () {
      this.registration_errors.push('Проверочный код устарел.');
    },
    registrationRecaptchaVerified: function (responseCode = false) {
      if (responseCode !== false) {
        this.captchaVerified = true;
        this.captchaCode = responseCode;
      } else {
        this.captchaVerified = false;
      }
    },
    registrationRecaptchaReseted: function () {
      this.captchaVerified = false;
      this.captchaCode = false;
    },
    submitRegistration: function () {
      let requestData = {
        person_firstname: this.firstname,
        person_lastname: this.lastname,
        person_midname: this.thirdname,
        phone_number: this.phonenumber,
        verify_code: this.verification_code,
        verified: true,
        referral_hash: this.referral_hash,
        captcha_code: this.captchaCode,
        permit_sms_messages: this.permit_sms_messages,
      };

      this.$store
          .dispatch('submitRegistration', requestData)
          .then(() => {
            let card_number = (typeof this.PARENT_PERSON.card_number !== "undefined") ? this.PARENT_PERSON.card_number : false;
            this.registrationStep = 3;
            this.afterRegisterTextFormatted = this.afterregister.replace(/#card_num#/gi, card_number);
          })
          .catch(err => {
            let errorObj;
            if ((typeof err.response !== "undefined") && (typeof err.response.data !== "undefined")) {
              errorObj = err.response.data;
            } else {
              errorObj = err;
            }
            this.registration_errors.push(this.getErrorTextFromApiJson(errorObj));
          });
    },
    resetRegistration: function () {
      this.firstname = null;
      this.lastname = null;
      this.thirdname = null;
      this.phonenumber = null;
      this.permit_sms_messages = null;
      this.agreement1 = null;
      this.agreement2 = null;
      this.verification_code = null;
      this.verification_code_input = null;
      this.verification_code_send_timestamp = null;
      this.registrationStep = 0;
      this.afterregister = null;
      this.afterRegisterTextFormatted = null;
      this.captchaVerified = false;
      this.captchaCode = false;
    },
    onlyLetterInput: function ($event) {
      if (!/[А-Яа-яA-Za-z]/.test(String.fromCharCode($event.which))) {
        $event.preventDefault();
        return false;
      }
    },
    checkPhoneNumber: function ($event) {
      let phone = !this.phonenumber ? '' : this.phonenumber;
      if (!/[+()//0-9]/.test(String.fromCharCode($event.which)) || phone.length > 15 ) {
        $event.preventDefault();
        return false;
      }
    },
    formatPhoneNumber: function ($event) {
      let phone = this.phonenumber,
          delLast = false,
          sLast,
          res_phone = ['+7('];

      if($event.keyCode == 8) {
        delLast = true;
      }

      if (!!phone && phone.length > 0) {
        let a = phone.replace('+7', '').replace(/[^0-9]/g, '').split('');
        if (a.length > 0) {
          for (let i = 0; i < 10 && i < a.length; i++) {
            res_phone.push(a[i]);
            if (i == 2) {
              res_phone.push(')');
            }
            if (i == 5 || i == 7) {
              res_phone.push('/');
            }
          }

          if (delLast) {
            //проверяем удаляемый символ
            sLast = res_phone.pop();
            if (/[0-9]/.test(sLast)) {
              res_phone.push(sLast);
            }
          }
          this.phonenumber = res_phone.join('');
        }
      }

      return null;
    },
    getSettings() {
      this.$store
          .dispatch('getSettings')
          .then(() => {
            this.pd_termsofuse = this.SETTINGS.pd_termsofuse;
            this.pd_processing_policy = this.SETTINGS.pd_processing_policy;
            this.pd_conditions = this.SETTINGS.pd_conditions;
            this.pd_policy = this.SETTINGS.pd_policy;
            this.pd_support_link = this.SETTINGS.pd_support_link;
            this.afterregister = this.SETTINGS.afterregister;
          })
          .catch(err => {
            console.log(err)
          });
    },
    getErrorTextFromApiJson(errorObj) {
      let errorText = "Сервис временно недоступен. Попробуйте позже";
      if (typeof errorObj.message === "object") {

        let errorObjectFirstKey = Object.keys(errorObj.message)[0];
        if (errorObj.message[errorObjectFirstKey].length() > 0 && typeof errorObj.message[errorObjectFirstKey] !== "undefined") {
          errorText = errorObj.message[errorObjectFirstKey].toString();
        }
      } else if (typeof errorObj.message === "string") {

        if (errorObj.message.indexOf("cURL error") === 0) {
          errorText = "Ошибка соединения с сервером.";
        }
        if (errorObj.message.indexOf("Too Many Attempts") === 0) {
          errorText = "Превышено максимальное число запросов в минуту.";
        }
      }

      return errorText;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->


<style lang="less" scoped>
.registration {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.registration-form,
.verification-form {
  width: 100%;
  text-align: left;

  &-errors,
  &-messages {
    width: 100%;
    margin-bottom: 1rem;

    & ul {
      list-style-type: none;
      padding: 0;
    }
  }

  &-errors {
    color: #640005;
  }

  &-messages {
    color: #24643b;
  }

  &-row {
    position: relative;
    margin-bottom: 0.8rem;

    &.required {

      &::after {
        content: "*";
        display: block;
        position: absolute;
        top: 0;
        right: 0.3rem;
        font-size: 1rem;
        color: #640005;
        pointer-events: none;
      }
    }

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  & input[type=text] {
    width: 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0.5rem 0.8rem;
    border: 1px solid #efefef;
    border-radius: 5px;
    font-size: 1rem;
    outline: none;

    &:focus {
      border-color: #226095;
    }
  }

  &-halfinput {
    & input[type=text] {
      width: 50%;
    }

    & label,
    & a {
      display: inline-block;
      box-sizing: border-box;
      width: 50%;
      padding-left: 5%;
    }
  }

  &-checkbox {

    &-wrapper {
      width: 10%;
      padding: 0.3rem 0;
      display: inline-block;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      text-align: left;
      vertical-align: top;
    }

    & input[type=checkbox] {
      width: 1.5rem;
      height: 1.5rem;
      border: 1px solid #226095;
      border-radius: 5px;
      outline: none;
    }

    & label {
      width: 90%;
      display: inline-block;
      text-align: left;
    }
  }

  &-button {
    padding: 0.5rem 0.8rem;
    border: 1px solid #226095;
    border-radius: 5px;
    font-family: inherit;
    font-weight: inherit;
    color: #226095;
    background: transparent;
    margin: 0 0.8rem;
    outline: none;

    &:hover {
      text-decoration: underline;
    }

    &:active {
      background: #226095;
      color: #ffffff;
    }

    &Filled {
      background: #226095;
      color: #ffffff;

      &:hover {
        text-decoration: underline;
      }

      &:active {
        background: transparent;
        color: #226095;
      }
    }

    &:first-of-type {
      margin-left: 0;
    }

    &:last-of-type {
      margin-right: 0;
    }
  }
}
</style>
